<button *ngIf="includeCloseButton" class="close-button">
  <ems-base-icon iconName="times" class="close-icon" (click)="close()"></ems-base-icon>
</button>
<ng-content select="[alert-icon]"></ng-content>
<ng-content select="[alert-title]"></ng-content>
<ng-content select="[alert-message]"></ng-content>
